/* RESPONSIBLE TEAM: team-standalone */

import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { taskFor } from 'ember-concurrency-ts';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import { type TaskInstance } from 'ember-concurrency';

export default class IntegrationRoute extends Route {
  @service declare appService: { app: { hasStandalonePlatform(platform: string): boolean } };
  @service declare finStandaloneService: FinStandaloneService;

  async beforeModel() {
    let promises: TaskInstance<void>[] = [];

    if (this.appService.app.hasStandalonePlatform('salesforce')) {
      if (this.finStandaloneService.isLoadingSalesforceLiveChatConfig) {
        promises.push(taskFor(this.finStandaloneService.loadSalesforceLiveChatConfig).lastRunning!);
      } else {
        promises.push(taskFor(this.finStandaloneService.loadSalesforceLiveChatConfig).perform());
      }

      if (this.finStandaloneService.isLoadingSalesforceInAppMessagingConfig) {
        promises.push(
          taskFor(this.finStandaloneService.loadSalesforceInAppMessagingConfig).lastRunning!,
        );
      } else {
        promises.push(
          taskFor(this.finStandaloneService.loadSalesforceInAppMessagingConfig).perform(),
        );
      }
    }

    await Promise.all(promises);
  }
}
